import { useMemo } from 'react';
import { useConstructorContext } from '../components/ConstructorProvider';
import { CONSTRUCTOR_MYSTIQUE_ID } from '../model/constants';
import { useConstructorSectionSettings } from '../model/slices';
import { useDenormalizedConstructorSection } from './useDenormalizedConstructorSection';

export const useAllowedToPasteReplaceSection = (props: { pageId: string; sectionInstanceId: string }) => {
    const { pageId, sectionInstanceId } = props;
    const section = useConstructorSectionSettings(pageId, sectionInstanceId);

    const { copiedSection } = useConstructorContext();

    const denormalizeSection = useDenormalizedConstructorSection();

    const currentWidget = useMemo(() => {
        if (section.widget !== CONSTRUCTOR_MYSTIQUE_ID) {
            return section.widget;
        }

        const denormalizedSection = denormalizeSection(section);

        if (!denormalizedSection) {
            return section.widget;
        }

        if ('template' in denormalizedSection && denormalizedSection.template.alias) {
            return denormalizedSection.template.alias;
        }

        return section.widget;
    }, [denormalizeSection, section]);

    const replaceWidget = useMemo(() => {
        if (!copiedSection) {
            return null;
        }

        if (copiedSection.widget !== CONSTRUCTOR_MYSTIQUE_ID) {
            return copiedSection.widget;
        }

        const denormalizedSection = denormalizeSection({
            ...copiedSection.sectionSettings,
            instance_id: '',
        });

        if (!denormalizedSection) {
            return copiedSection.widget;
        }

        if ('template' in denormalizedSection && denormalizedSection.template.alias) {
            return denormalizedSection.template.alias;
        }

        return copiedSection.widget;
    }, [denormalizeSection, copiedSection]);

    const canReplaceCheck =
        copiedSection &&
        copiedSection.sectionInstanceId !== section.instance_id &&
        !copiedSection.moduleId &&
        replaceWidget === currentWidget;

    return canReplaceCheck;
};
